<template>
  <div class="pa-4">
    <v-col lg="12" class="pt-0 pb-3">
      <div class="d-flex align-center justify-space-between flex-wrap">
        <v-btn @click="$router.back()" class="back-btn">
          <v-icon left>mdi-arrow-left</v-icon>
          VOLVER
        </v-btn>

        <v-btn
          color="success"
          v-if="global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])"
          @click="openModalScrap"
          class="btn-scrap-directo px-5 rounded-lg elevation-2 font-weight-bold white--text text-none"
          height="42"
        >
          <v-icon left size="22">mdi-plus-circle-outline</v-icon>
          Registrar neumático directo para SCRAP
        </v-btn>
      </div>
    </v-col>

    <v-col lg="12">
      <nuevo
        :Item="Item"
        :Vehiculos="Vehiculos"
        :MotivosScrap="MotivosScrap"
      ></nuevo>
    </v-col>

    <v-col lg="12">
      <tabla
        Titulo="Neumáticos en SCRAP"
        :Cabecera="Cabecera"
        :loading="Loader"
        :Items="Items"
        :ItemTotal="ItemTotal"
        :MotivosScrap="MotivosScrap"
        :Excel="false"
        :Crear="false"
      />
    </v-col>

    <Scrap
      v-if="global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])"
      ref="scrap"
      :dialog="dialog_scrap"
      :Marcas="Marcas"
      :Modelos="Modelos"
      :Medidas="Medidas"
      :Disenios="Disenios"
      :MotivosScrap="MotivosScrap"
      :Empresas="Empresas"
      @cargarNeumaticosScrap="cargarNeumaticosScrap"
      @dialog="dialog_scrap = $event"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Scrap from "@/components/scrap/scrap.vue";
import tabla from "@/components/scrap/tabla.vue";
import nuevo from "@/components/scrap/nuevo.vue";
import global from "@/global";
export default {
  components: {
    tabla,
    nuevo,
    Scrap,
  },
  data() {
    return {
      Cabecera: [
        { text: "Opciones", value: "acciones", align: "left", width: 120 },
        { text: "Id", value: "id", align: "left" },
        { text: "N° serie", value: "num_serie", align: "left", width: 100 },
        { text: "Marca", value: "marca", align: "left" },
        { text: "Modelo", value: "modelo", align: "left", width: 100 },
        { text: "Medida", value: "medida", align: "left", width: 100 },
        { text: "Diseño", value: "disenio", align: "left", width: 100 },
        { text: "Motivo Scrap", value: "motivo", align: "left", width: 180 },
        {
          text: "Fecha Scrap",
          value: "fecha_scrap",
          align: "left",
          width: 120,
        },
        {
          text: "Remanente final",
          value: "remanente_final",
          align: "left",
        },
        { text: "Remanente límite", value: "remanente_limite", align: "left" },
        { text: "Imagen", value: "image", align: "left" },
      ],
      Item: {},
      dialog_scrap: false,
      valid_form: false,
      global: global,
    };
  },
  computed: {
    ...mapState("scrap", [
      "Items",
      "ItemTotal",
      "Vehiculos",
      "MotivosScrap",
      "Marcas",
      "Modelos",
      "Medidas",
      "Disenios",
      "Empresas",
      "Loader",
    ]),
    ...mapState("navigation", ["Permisos"]),
  },
  methods: {
    ...mapActions("scrap", ["cargarNeumaticosScrap", "cargarDatosAdicionales"]),

    openModalScrap: function () {
      this.dialog_scrap = true;
    },
  },
  mounted: async function () {
    this.cargarNeumaticosScrap();
    await this.cargarDatosAdicionales();
  },
};
</script>

<style scoped>
.btn-scrap-directo {
  background: linear-gradient(135deg, #10b981 0%, #10b981 100%) !important;
  color: #ffffff !important;
  letter-spacing: 0.3px;
  font-size: 0.92rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.15);
}
</style>
